import { getAuth } from "firebase/auth";
import { getFirestore, doc, getDoc } from "firebase/firestore";

export default async function () {
    let auth = getAuth();
    let db = getFirestore();

    let docRef = doc(db, 'users', auth.currentUser.uid);
    return (await getDoc(docRef)).data().accountType;
}